import { WHY_CHOOSE_CARS_LIST,WHY_CHOOSE_CARS_SUCCESS,WHY_CHOOSE_CARS_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getWhyChooseCarsList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case WHY_CHOOSE_CARS_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case WHY_CHOOSE_CARS_SUCCESS:
            console.log('WHY_CHOOSE_CARS_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getWhyChooseCarsList: action.data,
                error: '',
                messages: ''
            };
        case WHY_CHOOSE_CARS_ERROR:
            return {
                ...state,
                loading: false,
                getWhyChooseCarsList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};
